// extracted by mini-css-extract-plugin
module.exports = {"absence_types":"AbsenceStatus_absence_types__h_vFH","absence_types_mobile":"AbsenceStatus_absence_types_mobile__J--Fv","absence_error":"AbsenceStatus_absence_error__EU2Uc"};